export function formatCurrency(amount: number) {
	return amount / 100;
}
